import { render, staticRenderFns } from "./ProductModifierQuantityControls.vue?vue&type=template&id=47b6b3f0&"
import script from "./ProductModifierQuantityControls.vue?vue&type=script&lang=js&"
export * from "./ProductModifierQuantityControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports